module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_feijoada.c236f743.png";